<div class="container-full has-background-white-bis mb-8">
  <div class="container">
    <div class="columns">
      <div class="column">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>
<div class="container mb-9">
  <div class="columns">
    <div class="column">
      <h1 class="title is-2 has-text-weight-bold has-line">Countries</h1>
      <p>
        The OECD INNOTAX portal covers all OECD member countries, EU member
        states and several other major economies that participate in the OECD
        The OECD INNOTAX portal covers all OECD member countries, EU member
        states and several other major economies that participate in the OECD
        survey on R&D tax incentives and OECD IPTAX survey on income-based tax
        incentives for R&D and innovation. The country-specific pages of the OECD
        INNOTAX portal provide a description of the design and implementation
        of expenditure-based and of the design of income-based tax incentives
        for all countries that provided such incentives in 2025 at central
        government level, either on a temporary or permanent basis, and for which
        relevant data are available (countries listed below and hyperlinked).
        For income-based tax incentives, information is also provided for incentives
        at the subnational level where available. In the case of expenditure-based
        incentives, information is also reported for selected countries on incentives
        that have expired and are no longer available at the time of reporting.
      </p>
      <br>
      <p>
        Click on a country to get information on its tax incentives.
      </p>
    </div>
  </div>

  <div class="columns is-multiline mt-1">
    <div
      *ngFor="let countryGroup of countryGroups"
      class="column is-12-mobile is-12-tablet is-12-desktop"
    >
      <div class="is-12 mb-1 has-text-weight-bold">
        {{ countryGroup.label }}:
      </div>

      <div class="columns is-multiline">
        <div
          *ngFor="let country of countryGroup.countries"
          class="column is-6-mobile is-13-tablet is-3-desktop"
        >
          <a *ngIf="country.pages"
            [routerLink]="['/countries', country.id]"
            class="button is-fullwidth is-square is-white is-flex is-align-items-center is-justify-content-flex-start"
          >
            <img
              class="flag is-small mr-2"
              [src]="'./assets/images/flags/' + country.image + '.png'"
              [alt]="country.label + ' flag'"
            />

            <span class="has-text-weight-normal has-custom-link">
                {{ country.label }}
             </span>
          </a>
          <div *ngIf="!country.pages"
            class="button is-fullwidth is-square is-white is-flex is-align-items-center is-justify-content-flex-start">
            <img
              class="flag is-small mr-2"
              [src]="'./assets/images/flags/' + country.image + '.png'"
              [alt]="country.label + ' flag'"
            />

            <span class="has-text-weight-normal">
                {{ country.label }}
             </span>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!countries">
      <div class="spinner column is-12">
        <div class="columns is-multiline">
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
